import {RootState} from "../../../store";
import {createSelector} from "@reduxjs/toolkit";

const selectMapState = (state: RootState) => state.map;

export const selectAllMachineryWithLocation = createSelector(
    [selectMapState],
    (machineryTasksState) => machineryTasksState.list,
);

export const selectIsMapConnected = createSelector(
    [selectMapState],
    (machineryTasksState) => machineryTasksState.isMapConnected,
);

export const selectMapIsLoading = createSelector(
    [selectMapState],
    (machineryTasksState) => machineryTasksState.isLoading,
);

export const selectMapCurrentMachineryId = createSelector(
    [selectMapState],
    (machineryTasksState) => machineryTasksState.current?.id || null,
);

export const selectCenterCounter = createSelector(
    [selectMapState],
    (machineryTasksState) => machineryTasksState.centerCounter,
);

export const selectMapTypeFilter = createSelector(
    [selectMapState],
    (machineryTasksState) => machineryTasksState.typeFilter,
);

/**
 * Список техники после применения фильтра по типу.
 * Единый источник правды и для карты (маркеры), и для панели —
 * фильтр везде даёт одинаковый набор машин.
 */
export const selectFilteredMachineryWithLocation = createSelector(
    [selectAllMachineryWithLocation, selectMapTypeFilter],
    (list, typeFilter) =>
        typeFilter == null ? list : list.filter((m) => m.type_id === typeFilter),
);